// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__pXyq9","image":"dashboard_image__5cIL6","text":"dashboard_text__reUrO"};